module.exports = __webpack_public_path__ + "img/attractions-fishing.e01c5daf.jpg";